import React, { Component } from 'react';

class AddressPopoverContent extends Component {
    render() {
        const { order } = this.props;
        const { name, address, province, postalCode } = order.address;

        return (
            <div style={{ fontSize: '16px' }}>
                <p style={{ fontWeight: 'bold' }}>{name}</p>
                <p>{address}</p>
                <p>{province}</p>
                <p>{postalCode}</p>
            </div>
        );
    }
}

export default AddressPopoverContent;



// WEBPACK FOOTER //
// ./src/views/orders/AddressPopoverContent.js